import { atom } from 'jotai';
import { ApiTypes } from 'common';

export const userAtom = atom<ApiTypes.ResGetMe['user'] | null>(null);
